import React from 'react';
import PropTypes from 'prop-types';

const iconProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
};

const DashboardIcon = () => (
  <svg {...iconProps}>
    <path d="M3 12 12 3l9 9" />
    <path d="M5 10v10h14V10" />
    <path d="M10 20v-6h4v6" />
  </svg>
);

const CollectIcon = () => (
  <svg {...iconProps}>
    <rect x="6" y="4" width="12" height="17" rx="2" />
    <path d="M9 4v2h6V4" />
    <path d="M9 11l2 2 4-4" />
  </svg>
);

const DataIcon = () => (
  <svg {...iconProps}>
    <path d="M12 3 3 7l9 4 9-4-9-4z" />
    <path d="M3 12l9 4 9-4" />
    <path d="M3 17l9 4 9-4" />
  </svg>
);

const StoriesIcon = () => (
  <svg {...iconProps}>
    <rect x="5" y="4" width="14" height="16" rx="2" />
    <path d="M9 8h6M9 12h6M9 16h4" />
  </svg>
);

const UsersIcon = () => (
  <svg {...iconProps}>
    <circle cx="9" cy="9" r="3.2" />
    <path d="M3 19c0-3 3-5 6-5s6 2 6 5" />
    <circle cx="17" cy="10" r="2.4" />
    <path d="M15 19c0-2 2-3.5 4-3.5" />
  </svg>
);

const HelpIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a13 13 0 0 1 0 18M12 3a13 13 0 0 0 0 18" />
  </svg>
);

const FallbackIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="8" />
  </svg>
);

const RAIL_ICONS = {
  dashboard: DashboardIcon,
  collect: CollectIcon,
  data: DataIcon,
  stories: StoriesIcon,
  users: UsersIcon,
  help: HelpIcon,
};

export const hasRailIcon = (name) => Boolean(RAIL_ICONS[name]);

const RailIcon = ({ name }) => {
  const Component = RAIL_ICONS[name] || FallbackIcon;
  return <Component />;
};

RailIcon.propTypes = {
  name: PropTypes.string,
};

RailIcon.defaultProps = {
  name: undefined,
};

export default RailIcon;
